import {
  SET_CURRENT_ITEM,
  PROFILE_PUSH
} from '../constants'

export const setCurrentItem = payload => ({ payload, type: SET_CURRENT_ITEM })

export const profilePush = payload => ({ payload, type: PROFILE_PUSH })
